// =============================================================
// Outfitter module entry — lazy shells for the four public surfaces, so the
// internal Harvus bundle never downloads outfitter code (and vice-versa).
// SELF-CONTAINED / REMOVABLE (see OUTFITTER_MODULE.md).
//
// The surface is chosen by path prefix in frontend/src/index.js:
//   /o/*      → OperatorApp   (tenant operator console)
//   /book/*   → BookingApp    (public, no-login booking)
//   /portal/* → PortalApp     (client/group portal, tokened)
//   /guide/*  → GuideApp      (guide mobile portal, Phase 6)
// =============================================================

import React, { Suspense, lazy } from 'react';

const OperatorApp = lazy(() => import('./operator/OperatorApp'));
const BookingApp = lazy(() => import('./book/BookingApp'));
const PortalApp = lazy(() => import('./portal/PortalApp'));
const GuideApp = lazy(() => import('./guide/GuideApp'));

function Loading() {
  return <div style={{ padding: 40, textAlign: 'center', fontFamily: 'Inter, system-ui, sans-serif', color: '#4a6572' }}>Loading…</div>;
}

// surface: 'operator' | 'book' | 'portal' | 'guide'
export function OutfitterSurface({ surface }) {
  const Comp = surface === 'operator' ? OperatorApp
    : surface === 'portal' ? PortalApp
    : surface === 'guide' ? GuideApp
    : BookingApp;
  return (
    <Suspense fallback={<Loading />}>
      <Comp />
    </Suspense>
  );
}
